<h1 mat-dialog-title>{{ 'field.workInstructions' | translate }}</h1>

<mat-dialog-content>
  <div class="row">
    <div class="col-12 mb-2" *ngFor="let item of items()">
      <mat-card>
        <mat-card-header>
          <mat-card-title> {{ item.name }}</mat-card-title>
          <mat-pill *ngIf="item.assignmentId" text="Assigned" class="m-1"></mat-pill>
        </mat-card-header>
        <mat-card-content>
          <div class="f-14">
            <mat-icon class="v-middle s-icon" matTooltip="{{ 'field.createdAt' | translate }}">event </mat-icon>
            {{ item.createdAt | utcToUserFormatted: true }}
          </div>
        </mat-card-content>
        <mat-card-actions align="end" class="space-btw gap-1">
          <button
            *ngIf="item.assignmentId && !data.onlyOpenMode"
            [disabled]="store.assignmentDialogStatus() === ELoadStatus.loading"
            mat-button
            type="button"
            (click)="askApplyChangesRecursively(item.assignmentId, 'unassign')"
          >
            {{ 'button.unassign' | translate }}
          </button>
          <button
            *ngIf="item.assignmentId"
            [disabled]="store.assignmentDialogStatus() === ELoadStatus.loading"
            mat-stroked-button
            type="button"
            (click)="onClickedOpenStepper(item.id)"
          >
            {{ 'button.open' | translate }}
          </button>
          <button
            *ngIf="!item.assignmentId"
            [disabled]="store.assignmentDialogStatus() === ELoadStatus.loading"
            mat-stroked-button
            type="button"
            (click)="askApplyChangesRecursively(item.id, 'assign')"
          >
            {{ 'button.assign' | translate }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    matButton="tonal"
    mat-dialog-close
    [disabled]="store.assignmentDialogStatus() === ELoadStatus.loading"
    (click)="closeDialog()"
  >
    {{ 'button.close' | translate }}
  </button>
</mat-dialog-actions>
